/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isprimaryteam2Inputs */

const en_entity_isprimaryteam2 = /** @type {(inputs: Entity_Isprimaryteam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Primary Team`)
};

const de_entity_isprimaryteam2 = /** @type {(inputs: Entity_Isprimaryteam2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primäres Team`)
};

/**
* | output |
* | --- |
* | "Is Primary Team" |
*
* @param {Entity_Isprimaryteam2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isprimaryteam2 = /** @type {((inputs?: Entity_Isprimaryteam2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isprimaryteam2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isprimaryteam2(inputs)
	return de_entity_isprimaryteam2(inputs)
});
export { entity_isprimaryteam2 as "entity_isPrimaryTeam" }